import React from "react";
import Box from "@/ui/atoms/Box";
import Typography from "@/ui/atoms/Typography";
import { Button } from "@proda-ai/ui-kit";
import type { CustomCellRendererProps } from "@/ui/molecules/Grid";
import type { AddFileRow } from "../dealTypes";

type UploadFileCellRendererProps = CustomCellRendererProps<AddFileRow> & {
    numOfExtractions: number;
    handleAddFileButtonClicked: (params: {
        databaseId: number;
        projectId: number;
    }) => void;
};

export const UploadFileCellRenderer: React.FC<UploadFileCellRendererProps> = ({
    node,
    handleAddFileButtonClicked,
}) => {
    const data = node.data;
    const projectId = data?.projectId;
    const databaseId = data?.databaseId;

    return (
        <Box
            sx={{
                ml: "3rem",
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-start",
                gap: "2rem",
                height: "100%",
                alignItems: "center",
            }}
            data-testid={`upload-file-${projectId}`}
        >
            <Button
                pattern="secondary"
                isInline={true}
                size={"small"}
                px={3}
                onClick={() =>
                    projectId !== undefined &&
                    databaseId !== undefined &&
                    handleAddFileButtonClicked({ databaseId, projectId })
                }
            >
                Add
            </Button>
            <Typography
                variant="body3"
                sx={{
                    color: "var(--text-color-disabled)",
                }}
            >
                Upload your first document to get started
            </Typography>
        </Box>
    );
};
